import React from 'react';

import { LinkBlockItemActive } from '@app/objects/LinkBlockItem';

export const petLossGroupLinkItems: Array<LinkBlockItemActive> = [
	{
		path: '/our-services/veterinary-hospice',
		name: 'Veterinary Hospice',
	},
	{
		path: '/our-services/in-home-euthanasia',
		name: 'In-Home Euthanasia',
	},
	{
		path: '/our-services/aftercare',
		name: 'Aftercare',
	},
	{
		path: '/our-services/telehospice',
		name: 'Telehospice',
	},
	{
		path: '/our-services/pet-loss-support',
		name: 'Pet Loss Support',
		active: true,
	},
];

export const navItems = [
	{
		name: 'journey',
		title: 'Pet Loss Support Groups',
	},
	{
		name: 'personal',
		title: 'Speciality Groups',
	},
	{
		name: 'group',
		title: 'Pet Loss Journey Courses',
	},
	{
		name: 'keepsakes',
		title: 'Individual Support',
	},
];

export const armsOfLoveText = (
	<>
		<p>
			These courses are designed for pet parents who wish to gain an additional level of knowledge and support regarding the loss of their pet.
			Developed by our pet loss support team, the curriculum is educational, and each session focuses on specific aspects of losing a beloved
			pet. Attendees will learn more about their loss, with reflection activities recommended between sessions to assist everyone in their grief
			journey. Participation and sharing are highly encouraged in these small group sessions. These sessions are held via Zoom and are led by an
			experienced grief coach.
		</p>
		<p style={{ fontStyle: 'italic' }}>Cost: $175.00 for the program</p>
		<p>
			<a
				href="https://petlosssupportgroupschedule.as.me/schedule/d5ca99cf/?categories[]=Curriculum"
				className="btn btn-md btn-primary"
				target="_blank"
				rel="nofollow noreferrer"
			>
				Register for the program
			</a>
		</p>
		<p style={{ fontStyle: 'italic' }}>
			*This program is limited to 6 participants per session. It is designed to allow an intimate group setting with open dialogue at the end of
			each session.
		</p>
	</>
);

export const petLossSupportGroupsText = (
	<>
		<p>
			Many pet parents feel alone when their beloved pet dies. Lap of Love is honored to walk with you in your grief journey and invites you to
			attend one of our coach-led, educational support groups. These free, listen-and-learn sessions are presented by a compassionate,
			professional grief coach and provide a safe, empathetic environment for those who are struggling with loss. Anyone who has experienced the
			loss of a pet is welcome to attend. Sessions are available several times throughout the week virtually via Zoom.
		</p>
		<p>
			<a
				href="https://petlosssupportgroupschedule.as.me/schedule/d5ca99cf/?"
				className="btn btn-md btn-primary"
				target="_blank"
				rel="nofollow noreferrer"
			>
				Reserve my spot
			</a>
		</p>
	</>
);

export const specialitySupportGroupsText = (
	<>
		<p>
			Our specialty support groups focus on targeted topics that cater to specific grief needs. These small groups provide a more intimate and
			personalized experience, and members will have the opportunity to share and receive guidance from a professional grief coach. Sessions
			emphasize healthy coping skills, grief reactions, and honoring the life of your loved one. Anyone who has experienced the loss
			of a pet is welcome to attend. Meetings take place virtually via Zoom.
		</p>
		<p>
			<a href="https://petloss.lapoflove.com/#featured" className="btn btn-md btn-primary" target="_blank" rel="noopener noreferrer">
				Reserve my spot
			</a>
		</p>
	</>
);

export const individualSupportText = (
	<>
		<p>
			Grieving the loss of a pet is a very personal experience and the journey to healing is different for everyone. Our individual support
			sessions are for pet parents who desire personalized support on how to heal following the loss of their beloved pet. Individual call
			sessions are led by a highly trained, professional grief coach who will offer a compassionate ear and a caring safe space for the sharing
			of feelings and emotions surrounding the death of a loved pet.
		</p>
		<p style={{ fontStyle: 'italic' }}>Cost: $55.00 for a 50-minute session</p>
		<p>
			<a
				href="https://petlosssupportgroupschedule.as.me/schedule/d5ca99cf/appointment/22514485?categories[]=One%20on%20One"
				className="btn btn-md btn-primary"
				target="_blank"
				rel="noopener noreferrer"
			>
				Schedule a session
			</a>
		</p>
		<p style={{ fontStyle: 'italic' }}>
			*Individual support sessions are not meant to be a substitute for mental health support with a licensed mental health counselor. Our pet
			loss support offerings are available as a “companioning” model, providing support to the caller, not counseling. Callers will be provided
			with additional counseling service referrals if requested.
		</p>
	</>
);

export const memorializeTitle = 'Memorialize your pet';
export const memorializeText = (
	<>
		<p>
			When your pet is no longer physically present, keeping their memory alive through a memento or keepsake can both honor them and help ease
			the grieving process. Whether it’s a painting of your pet or a necklace made from their pawprint, an object that you can hold in your hand
			creates a sense of everlasting connection.
		</p>
		<p>
			Our Pet Memorial Keepsakes site was created for those who seek comfort in mementos after saying goodbye to a pet. The site offers a range
			of unique memorial items from carefully selected companies. We hope you find an item that perfectly symbolizes the forever bond between
			you and your beloved friend.
		</p>
		<p>
			<a href="https://info.lapoflove.com/keepsakes" className="btn btn-md btn-primary" target="_blank" rel="noopener noreferrer">
				View Keepsakes
			</a>
		</p>
	</>
);

export const disclaimerTitle = 'MENTAL HEALTH DISCLAIMER:';
export const disclaimerText = (
	<>
		<p>
			<i>
				The loss of an animal companion can lead to challenging emotional responses that warrant professional mental health support which is
				beyond the scope and training of the Lap of Love Pet Loss Resource Line staff. While we are here to provide compassionate grief
				support, we are unable to appropriately evaluate human mental health concerns and do not provide mental health counseling. The
				services of the Pet Loss Resource Line are not intended to directly support or provide a substitute for definitive mental health care,
				especially in a crisis. We may be able to help you find pet loss support resources in your area, but we cannot provide referrals to
				specific mental health services.
			</i>
		</p>
		<h3 className="rich-text__title">
			If you or someone you’re concerned about is depressed, unable to cope, or having thoughts of self-harm or harming others, IMMEDIATELY call
			the 988 Suicide & Crisis Lifeline by dialing 988 or call your local non-emergency resource center. For emergency services, please dial
			911.
		</h3>
	</>
);
export const disclaimerAddText = (
	<>
		<h3 className="rich-text__title">Additional emergency and crisis services include:</h3>
	</>
);

export const emergencyService = [
	{
		url: 'https://988lifeline.org',
		title: 'The 988 Suicide & Crisis Lifeline',
		description: (
			<>
				Call or text the 3-digit nationwide code:
				{' '}
				<b>
					<a href="tel:988">988</a>
				</b>
				<br />
				Online chat:
				{' '}
				<b>
					<a href="https://988lifeline.org">988lifeline.org</a>
				</b>
				<br />
				24/7, free, confidential support for people in distress. Prevention and crisis resources.
			</>
		),
	},
];
export const additionalServices = [
	{
		url: 'http://www.suicide.org/suicide-hotlines.html',
		title: 'Suicide Hotline Numbers by State',
		description: 'Suicide prevention, awareness, and support',
	},
	{
		url: 'https://www.crisistextline.org/',
		title: 'Crisis Text Line',
		description:
			'Text HOME to 741741 from anywhere in the United States, anytime, about any type of crisis. A live, trained Crisis Counselor receives the text and responds from the Crisis Text Line’s secure online platform.',
	},
	{
		url: 'https://nami.org/Home',
		title: 'National Alliance on Mental Illness (NAMI)',
		description: (
			<>
				<a href="tel:8009506264">800-950-6264</a>
				<br />
				Text NAMI to 741741
				<br />
				Confidential, free crisis counseling
			</>
		),
	},
	{
		url: 'https://www.211.org/',
		title: '211',
		description: 'Call 211 to get immediate, expert help and also to find on-going local support.',
	},
	{
		url: 'https://www.veteranscrisisline.net/',
		title: 'Veterans Crisis Line',
		description: (
			<>
				<a href="tel:8002738255">800-273-8255</a>
				{' '}
				(TALK), Press 1 or text 838255
				<br />
				24/7 service for veterans and their loved ones
			</>
		),
	},
	{
		url: 'https://www.thetrevorproject.org/',
		title: 'The Trevor Project',
		description: (
			<>
				<a href="tel:8664887386">866-488-7386</a>
				{' '}
				or text START to 678678
				<br />
				24/7 crisis and suicide prevention services to LGBTQ+ people
			</>
		),
	},
	{
		url: 'https://www.listenersoncall.com/',
		title: 'Listeners on Call',
		description: (
			<>
				Connect anyone, anywhere, anytime with someone who has a related personal experience and is ready to listen. Visit their site for
				pricing information and to download their app.
			</>
		),
	},
	{
		url: 'https://nationaldepressionhotline.org/',
		title: 'National Depression Hotline',
		description: (
			<>
				<a href="tel:8666294564">866-629-4564</a>
				<br />
				Free 24/7 nationwide hotline for people struggling with depression and post-traumatic stress disorder.
			</>
		),
	},
];
